import { render, staticRenderFns } from "./consent-bank-logs-tab.vue?vue&type=template&id=43d6200e&scoped=true"
import script from "./consent-bank-logs-tab.vue?vue&type=script&lang=js"
export * from "./consent-bank-logs-tab.vue?vue&type=script&lang=js"
import style0 from "./consent-bank-logs-tab.vue?vue&type=style&index=0&id=43d6200e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6200e",
  null
  
)

export default component.exports